module.exports = __webpack_public_path__ + "img/happi_1_Small.b377fc33.png";